<template>
  <div class="radio-button radio-button__wrapper">
    <template v-for="button in buttonData">
      <input
        :id="button.id"
        :value="button.value"
        :name="name"
        :key="button.id"
        class="radio-button radio-button__input"
        type="radio"
        v-on="$listeners"
      >
      <label
        :for="button.id"
        :key="button.id"
        class="radio-button radio-button__label"
      >
        <span class="radio-button__text">{{ button.label }}</span>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: "RadioButton",
  props: {
    buttonData: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  }
};
</script>
